// Generated by scripts/build-info.mjs - do not edit, not committed.
export const BUILD_INFO = {
  sha: 'd3300c0a4460b6d32e6f2095f7e9510b9bcf8f13',
  short: 'd3300c0',
  builtAt: '2026-10-24T16:55:58.421Z',
} as const;
